module.exports = __webpack_public_path__ + "img/james-smith.fadca5a5.png";